import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const DemurrageUploadConfig = {
    auth: [...authRoles.admin, ...authRoles.processor],
    routes: [{ exact: true, path: '/demurrage-upload', component: FuseLoadable({ loader: () => import('./DemurrageUploadApp') }) }],
};

export default DemurrageUploadConfig;
